import notificationHTTP from '@/api/modules/notification/notification'
// import userHTTP from '@/api/modules/user/user'
const state = {
	totalNumber: 0,
	notifications: []
}

const mutations = {
	SET_TOTAL_NUMBER: (state, value) => {
		state.totalNumber = value
	},
	SET_NOTIFICATIONS: (state, items) => {
		state.notifications = items
	}
}

const actions = {
	sync: (context, playSound = false) => {
		let queryParams = {
			status: 0
		}
		notificationHTTP.findAll(queryParams).then((response) => {
			let index = 1
			let notifications = response.body
			context.commit('SET_TOTAL_NUMBER', notifications.length)
			if (notifications.length === 0) context.commit('SET_NOTIFICATIONS', [])
			notifications.forEach((value, key) => {
				// userHTTP.findOne(value.user_id).then((user) => {
				// notifications[key].user = user
				if (index === notifications.length) {
					context.commit('SET_NOTIFICATIONS', notifications)
					if (playSound === true) {
						let audio = new Audio('/static/audio/definite.mp3')
						audio.play()
					}
				}
				index++
			// })
			})
		})
	},
	socket_socketNotificationMsg: (context, message) => {
		context.dispatch('sync', true)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notification.js